<template>
  <div class="container-fluid main_content">

    <location-line :step1="'차량관리'" :step2="'세부 차량관리'"/>
    <car-info-box/>
    <div class="tabs">
      <nav class="nav justify-content-start">
        <!-- <router-link tag="div" class="nav-link"
                     :to="{ name:'CarExpend', params:{seq:this.$route.params.seq}, query: $route.query, hash: $route.hash}"
                     :class="this.$route.name === 'carExpend' ? 'router-link-active':''">
          소모품 관리
          <span class="bottom_border"></span>
        </router-link> -->
        
        <router-link tag="div" class="nav-link"
                     :to="{ name:'CarDiag', params:{seq:this.$route.params.seq}, query: $route.query, hash: $route.hash}">
          차량 진단 및 평가
          <span class="bottom_border"></span>
        </router-link>
      </nav>
    </div>
    <div class="sub_content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import LocationLine from '@/components/LocationLine'
import CarInfoBox from '@/components/CarInfoBox'

export default {
  name: 'CarView',
  components: {
    LocationLine,
    CarInfoBox
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  padding: 30px 15px 15px 15px;
  font-size: 12px;

  .nav {
    border-bottom: 1px solid #F0F0F0;
  }

  .nav-link {
    color: #979799;
    position: relative;
    padding: 0px;
    cursor: pointer;
    height: 30px;
    margin: 0px 20px 0px 0px;

    &.router-link-active {
      color: #007DEF;

      .bottom_border {
        display: inline-block;
        position: absolute;
        left: 0px;
        bottom: 0px;
        height: 5px;
        width: 100%;
        background: #007DEF;
        border-radius: 10px 10px 0px 0px;
      }
    }

  }
}

.sub_content {
  padding: 15px;
}
</style>
